module.exports = __webpack_public_path__ + "static/media/checkmark-box-filled-green.00a8092a.svg";